module.exports = __webpack_public_path__ + "static/fcra-2015-16-q4-874a55d4f9822c7068052f591c87a9c1.pdf";